import apiKeys from 'apiKeys.json'
import { ConstantsType } from './typings'
import { locales } from './locales'
import defaultConfig from './locales/default'
import { BRAND_LIST, Languages } from '../typings'

const getConstants = (): ConstantsType => {
  try {
    const {
      REACT_APP_BRAND,
      REACT_APP_BASE_URL,
      REACT_APP_GMAP_KEY,
    } = process.env

    const path = window.location.pathname
    const parts =
      /^\/(\w{2})\/(\w{2})/.exec(path) ||
      /^\/([\w-]{5})\/(\w{2})/.exec(path) ||
      []

    const BRAND = (REACT_APP_BRAND || 'uq') as BRAND_LIST
    const COUNTRY = (parts[1] || 'jp') as keyof typeof locales
    const LANGUAGE = (parts[2] || 'ja') as Languages

    // TODO
    // dynamically import locale config
    // support default configs

    const BASE_NAME = `/${COUNTRY}/${LANGUAGE}`

    const regionConfig = locales[COUNTRY]

    if (regionConfig.IS_EU) {
      const euCountryData = defaultConfig.EU_COUNTRY_LIST!.find(
        country => country.countryCode === COUNTRY,
      )

      if (euCountryData && euCountryData.defaultTo) {
        const defaultToConfig =
          locales[euCountryData.defaultTo as keyof typeof locales]

        regionConfig.GEO_COORDINATES = defaultToConfig.GEO_COORDINATES
      }
    }

    const brandLanguageConfigOverrides =
      (regionConfig[BRAND] && regionConfig[BRAND]![LANGUAGE]) || {}

    const uqBaseUrl = process.env.REACT_APP_BASE_URL || 'https://www.uniqlo.com'
    const BASE_URL = `${uqBaseUrl}${BASE_NAME}`
    const HOME_PAGE_URL = `${REACT_APP_BASE_URL}${BASE_NAME}`

    return {
      ...defaultConfig,
      ...regionConfig,
      ...brandLanguageConfigOverrides,
      GOOGLE_MAPS_API_KEY: REACT_APP_GMAP_KEY,
      COUNTRY,
      LANGUAGE,
      BASE_NAME,
      BASE_URL,
      BRAND,
      HOME_PAGE_URL,
    } as ConstantsType
  } catch (error) {
    throw new Error('Unable to determine constants')
  }
}

export default getConstants
